module.exports = __webpack_public_path__ + "img/success.9dd0a1c3.png";